import axios, { throwAxiosError } from './request';
import { Project } from '../Types/Project';

const endpoint = `/projects/`;

export interface PaginatedProjectsResponse {
  count: number;
  next: number;
  previous: number;
  results: Project[];
}

export interface ProjectsQueryParams {
  type?: 'user_project' | 'quote_request';
}

export const getProjects = async (
  params?: ProjectsQueryParams
): Promise<PaginatedProjectsResponse | null> => {
  try {
    const { data } = await axios.get(endpoint, { params });
    if (data) {
      return data as PaginatedProjectsResponse;
    }
  } catch (error) {
    throwAxiosError(error);
  }
  return null;
};

export const createProject = async (p: Project): Promise<Project | null> => {
  try {
    const { data } = await axios.post(endpoint, p);
    if (data) {
      return data as Project;
    }
  } catch (error) {
    throwAxiosError(error);
  }
  return null;
};

export const updateProject = async (p: Project): Promise<Project | null> => {
  try {
    const { data } = await axios.put(endpoint, p);
    if (data) {
      return data as Project;
    }
  } catch (error) {
    throwAxiosError(error);
  }
  return null;
};

export const archiveProject = async (
  id: string | number
): Promise<Project | null> => {
  try {
    const { data } = await axios.patch(`${endpoint}${id}/`, {
      status: 'archived',
    });
    if (data) {
      return data as Project;
    }
  } catch (error) {
    throwAxiosError(error);
  }
  return null;
};

export const deleteProject = async (id: string | number): Promise<null> => {
  try {
    await axios.delete(`${endpoint}${id}/`);
  } catch (error) {
    throwAxiosError(error);
  }
  return null;
};

export const getProject = async (
  id: string | number
): Promise<Project | null> => {
  try {
    const { data } = await axios.get(`${endpoint}${id}/`);
    if (data) {
      return data as Project;
    }
  } catch (error) {
    throwAxiosError(error);
  }
  return null;
};
